import { gql } from 'apollo-angular';

export const CREATE_TAXI_FLEET_ACCOUNT = gql`
  mutation CreateFleetAccount($input: CreateFleetAccountInput!) {
    createFleetAccount(createFleetAccountInput: $input) {
      fleetId
      fleetCode
      operatorName
      registeredBusinessName
      representativeFirstName
      representativeLastName
      representativeEmail
      representativeMobile
      ltfrbCpcNumber
      fleetType
      cpcExpirationDate
      documents {
        fleetDocumentId
        documentUrl
        documentType
      }
      allowedActiveVehicles
      status
      declineRemarks
      dateApproved
      dateCreated
      dateUpdated
    }
  }
`;


export const ADD_FLEET_DOCUMENT = gql`
  mutation AddFleetDocument($input: AddFleetDocumentInput!) {
    addFleetDocument(addFleetDocumentInput: $input) {
      fleetDocumentId
      fleetId
      documentUrl
      documentType
      dateCreated
      dateUpdated
    }
  }
`;


export const DELETE_FLEET_DOCUMENT = gql`
  mutation DeleteFleetDocument($fleetDocumentId: HashedId!) {
    deleteFleetDocument(fleetDocumentId: $fleetDocumentId)
  }
`;


export const UPDATE_TAXI_FLEET_ACCOUNT_STATUS = gql`
  mutation UpdateFleetStatus($input: UpdateFleetStatusInput!) {
    updateFleetStatus(updateFleetStatusInput: $input) {
      fleetId
      fleetCode
      operatorName
      registeredBusinessName
      representativeFirstName
      representativeLastName
      representativeMobile
      ltfrbCpcNumber
      fleetType
      cpcExpirationDate
      status
      declineRemarks
      dateApproved
      dateCreated
      dateUpdated
    }
  }
`;

/** Admin deactivate of an approved fleet operator (sets status INACTIVE). */
export const DEACTIVATE_FLEET_OPERATOR = gql`
  mutation DeactivateFleetOperator($input: DeactivateFleetOperatorInput!) {
    deactivateFleetOperator(deactivateFleetOperatorInput: $input) {
      fleetId
      fleetCode
      operatorName
      status
      declineRemarks
      dateUpdated
    }
  }
`;

/** Admin activate of an inactive fleet operator (sets status APPROVED). */
export const ACTIVATE_FLEET_OPERATOR = gql`
  mutation ActivateFleetOperator($input: ActivateFleetOperatorInput!) {
    activateFleetOperator(activateFleetOperatorInput: $input) {
      fleetId
      fleetCode
      operatorName
      status
      declineRemarks
      dateUpdated
    }
  }
`;

export const APPROVE_FLEET_ENROLLMENT = gql`
  mutation ApproveFleetEnrollment($input: ApproveFleetEnrollmentInput!) {
    approveFleetEnrollment(approveFleetEnrollmentInput: $input) {
      fleetId
      operatorName
      status
    }
  }
`;

export const DECLINE_FLEET_ENROLLMENT = gql`
  mutation DeclineFleetEnrollment($input: DeclineFleetEnrollmentInput!) {
    declineFleetEnrollment(declineFleetEnrollmentInput: $input) {
      fleetId
      operatorName
      status
      declineRemarks
    }
  }
`;

export const TAG_FLEET_ENROLLMENT_FOR_AMENDMENT = gql`
  mutation TagFleetEnrollmentForAmendment($input: TagFleetEnrollmentForAmendmentInput!) {
    tagFleetEnrollmentForAmendment(tagFleetEnrollmentForAmendmentInput: $input) {
      fleetId
      status
    }
  }
`;

/** Admin per-document approve / tag-for-amendment. Caller: taxi-fleet-details.component.ts */
export const REVIEW_FLEET_DOCUMENT = gql`
  mutation ReviewFleetDocument($input: ReviewFleetDocumentInput!) {
    reviewFleetDocument(reviewFleetDocumentInput: $input) {
      fleetDocumentId
      fleetId
      documentUrl
      documentType
      status
      remarks
      dateUpdated
    }
  }
`;

/** Admin > Fleets > Update Fleet Registry Status (Postman OKITO workspace) */
export const ADMIN_UPDATE_FLEET_VEHICLE_REGISTRY_STATUS = gql`
  mutation AdminUpdateFleetVehicleRegistryStatus($input: AdminUpdateFleetVehicleRegistryStatusInput!) {
    adminUpdateFleetVehicleRegistryStatus(input: $input) {
      fleetVehicleRegistryId
      fleetId
      fleetAccountId
      plateNumber
      conductionNumber
      vehicleType
      vehicleModel
      yearModel
      vehicleMaker
      vehicleId
      status
      dateCreated
      dateUpdated
    }
  }
`;

export const UPDATE_FLEET_OPERATOR_DETAILS = gql`
  mutation UpdateFleetOperatorDetails($input: UpdateFleetOperatorDetailsInput!) {
    updateFleetOperatorDetails(updateFleetOperatorDetailsInput: $input) {
      fleetId
      fleetCode
      operatorName
      registeredBusinessName
      representativeFirstName
      representativeLastName
      representativeEmail
      representativeMobile
      ltfrbCpcNumber
      fleetType
      cpcExpirationDate
      allowedActiveVehicles
      status
      dateUpdated
      accountHolder {
        firstName
        lastName
        email
        mobile
      }
    }
  }
`;

export const RESEND_FLEET_LOGIN_CREDENTIALS = gql`
  mutation ResendFleetLoginCredentials($input: ResendFleetLoginCredentialsInput!) {
    resendFleetLoginCredentials(resendFleetLoginCredentialsInput: $input)
  }
`;
